export default __webpack_public_path__ + "static/media/seinfeld.45f50193.png";